import { defineComponent as _defineComponent } from 'vue'

import { ref, computed, onUnmounted } from 'vue';

import { useRouter } from '@router';
import { useStore } from '@store';
import { externalLinks } from '@values';

import LittleArmsStudios from '@components/SVGs/LittleArmsStudios.vue';
import Toothy from '@components/SVGs/Toothy.vue';

import { faApple } from '@icons/brands/faApple';
import { faWindows } from '@icons/brands/faWindows';
import { faEarthAmericas } from '@icons/solid/faEarthAmericas';

/** App version. */
const VERSION = process.env.PACKAGE_VERSION;

/**
 * Internal site link configuration.
 */
interface InternalSiteLink {
  key: string;
  label: string;
  route: string;
}

const COMPANY_LINKS: InternalSiteLink[] = [
  {
    key: 'about',
    label: 'About',
    route: 'about',
  },
  {
    key: 'terms',
    label: 'Terms',
    route: 'termsAndConditions',
  },
  {
    key: 'privacy',
    label: 'Privacy',
    route: 'privacyPolicy',
  },
  {
    key: 'cookies',
    label: 'Cookies',
    route: 'cookies',
  },
  {
    key: 'shipping',
    label: 'Shipping',
    route: 'shippingPolicy',
  },
  {
    key: 'returns',
    label: 'Returns',
    route: 'returns',
  },
];

const RESOURCE_LINKS = [
  externalLinks.roadmap,
  externalLinks.patchNotes,
  externalLinks.wiki,
  externalLinks.faqs,
];

const PLATFORM_LINKS = [
  externalLinks.enterpriseBilling,
  externalLinks.integrations,
  externalLinks.security,
  externalLinks.status,
];

const SOCIAL_LINKS = [
  externalLinks.facebook,
  externalLinks.twitter,
  externalLinks.instagram,
  externalLinks.linkedin,
  externalLinks.youtube,
];

const __default__ = { name: 'AppFooter' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

/** Current year. */
const year = new Date().getFullYear();

const router = useRouter();
const store = useStore();

const routeName = ref(router.currentRoute.name ?? null);

onUnmounted(
  router.afterEach((to) => {
    routeName.value = to.name ?? null;
  }),
);

/** `true` if the footer should be rendered, otherwise `false`. */
const enabled = computed(() => {
  return (
    // Wait until initial route navigation has completed to avoid flashing
    // of footer on page load.
    store.state.initialNavigationCompleted &&
    routeName.value !== 'checkout' &&
    routeName.value !== 'publicProfile' &&
    routeName.value !== 'onboarding' &&
    !(routeName.value ?? '').startsWith('dashboard')
  );
});

return { __sfc: true,VERSION, COMPANY_LINKS, RESOURCE_LINKS, PLATFORM_LINKS, SOCIAL_LINKS, year, router, store, routeName, enabled, LittleArmsStudios, Toothy, faApple, faWindows, faEarthAmericas }
}

})